import { Button, Container, Grid, MenuItem, Select } from '@mui/material';
import usePagination from 'src/hooks/usePagination';
import CustomTable from 'src/components/table/table';
import TabTitle from 'src/components/tabTitle/tabTitle';
import { DELETE_USER, GET_USER } from 'src/apiService/apiDeclaration';
import { userTableColumns } from 'src/constants/columnConfig';
import { roleArray, showErrorTost, showSuccessTost } from 'src/constants';
import { useModal } from 'src/hooks/useModal';
import AddUserForm from 'src/components/form/AddUserForm';
import MenuPopover from 'src/components/menu/menu';
import { ICONS } from 'src/assets/library';
import PageHeader from 'src/components/pageHeader/PageHeader';
import { USER_ROLES } from 'src/config/enum';
import { t } from 'i18next';
import { useState } from 'react';

const UserPage = () => {
  const defaultRoles = [USER_ROLES.CEO, USER_ROLES.ADMINISTRATOR, USER_ROLES.OPERATOR].join(',');
  const [selectedRole, setSelectedRole] = useState('default');
  const { setDialogData, handleModalClose } = useModal();
  const updatedUserTable = [...userTableColumns];
  const { paginationModel, setPaginationModel, loading, data, refresh, setQuerryParams } = usePagination(GET_USER, {
    role: defaultRoles,
  });

  const onSuccess = () => {
    handleModalClose();
    refresh();
  };

  const onDelete = async (id) => {
    try {
      await DELETE_USER(id);
      onSuccess();
      showSuccessTost(t('common.adminDeleteSuccessMessage'));
    } catch (error) {
      showErrorTost(t('common.adminDeleteFailureMessage'));
    }
  };

  updatedUserTable.push({
    field: 'action',
    headerName: 'Action',
    sortable: false,
    disableColumnMenu: true,
    width: 80,
    renderCell: ({ row }) => {
      return (
        <MenuPopover
          menuArray={[
            {
              icon: ICONS.delete,
              name: t('common.delete'),
              action: () => {
                setDialogData({
                  showModal: true,
                  description: t('common.delConfirmation'),
                  onConfirm: () => onDelete(row._id),
                });
              },
            },
            {
              icon: ICONS.edit,
              name: t('common.edit'),
              action: () => {
                setDialogData({
                  showModal: true,
                  title: t('menu.editUser'),
                  child: <AddUserForm onSuccess={() => onSuccess()} data={row} />,
                });
              },
            },
          ]}
        />
      );
    },
  });

  const onStatusChange = (value) => {
    setSelectedRole(value);
    if (value === 'default') {
      setQuerryParams({ role: defaultRoles });
    } else {
      setQuerryParams({ role: [value] });
    }
  };
  return (
    <Container>
      <Grid container spacing={2}>
        <TabTitle title={'Users'} />
        <Grid item xs={12}>
          <Grid
            container
            xs={12}
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              justifyContent: 'space-between',
              alignItems: { xs: 'flex-start', sm: 'center' },
              gap: { xs: 2, sm: 0 },
            }}
          >
            <Grid item xs={12} sm={6}>
              <PageHeader pageTitle={t('common.admin')} />
            </Grid>
            <Grid item xs={12} sm={6} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'end', gap: 2 }}>
              <Grid item xs={8} sm={6} sx={{ width: '300px' }}>
                <span>{t('common.role')}</span>
                <Select fullWidth size="small" value={selectedRole} onChange={(e) => onStatusChange(e.target.value)}>
                  {roleArray.map(({ value, label }, index) => (
                    <MenuItem key={index} value={value}>
                      {t(`labels.${label}`)}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
              <Button
                xs={4}
                variant="contained"
                onClick={() =>
                  setDialogData({
                    showModal: true,
                    title: t('userPage.modalHeading'),
                    child: <AddUserForm onSuccess={() => onSuccess()} />,
                  })
                }
              >
                {t('userPage.addUser')}
              </Button>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <CustomTable
            loading={loading}
            isServerSidePagination
            paginationModel={paginationModel}
            setPaginationModel={setPaginationModel}
            columns={updatedUserTable}
            rows={data.rows}
            rowCount={data.rowCount}
          />
        </Grid>
      </Grid>
    </Container>
  );
};

export default UserPage;
